import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {HOTB} from "../HOTB";
import {GameConfig} from "../GameConfig";

export class GameOverlay extends PIXI.Container implements StageLayer {
    private _trimmedOverlay: PIXI.Sprite;
    private _overlayTL: gsap.core.Timeline | undefined;
    private _overlayMaxAlpha: number = 0.6;

    constructor() {
        super();
        this.name = "GameOverlay";
        this.init();
    }

    public toggleTrimmedOverlay(show: boolean): gsap.core.Timeline {
        this.resetOverlayTimeline();

        this._overlayTL = gsap.timeline();

        this._overlayTL.to(this._trimmedOverlay, {
            alpha: show ? this._overlayMaxAlpha : 0,
            duration: GameConfig.SATAN_SPIN_SYMBOL_DROP_TIME
        });

        return this._overlayTL;
    }

    private init(): void {
        this.createTrimmedOverlay();
    }

    private createTrimmedOverlay(): void {
        this._trimmedOverlay = new PIXI.Sprite(HOTB.assetLoader.getTextures("blackTrimmedOverlay")[0]);
        this._trimmedOverlay.position.set(360, 360);
        this._trimmedOverlay.anchor.set(0.5, 0.5);
        this._trimmedOverlay.alpha = 0;
        this.addChild(this._trimmedOverlay);
    }

    private resetOverlayTimeline(): void {
        if (this._overlayTL && this._overlayTL.isActive()) {
            this._overlayTL.progress(1);
            this._overlayTL.pause();
            this._overlayTL.kill();
            this._overlayTL = undefined;
        }
    }
}